import { createService } from '@bonanza-social/toolkit/api';
import { StatusConfigResponseSchema } from './StatusConfigService.schemas';

export default createService({
  getStatusConfig: {
    method: 'GET',
    url: '/loyalty/statuses',
    responseSchema: StatusConfigResponseSchema,
  },
});
